import React, { Component } from 'react';

import { FacebookSDKContext } from './context';

class FacebookConsumer extends Component {
  render() {
    return (
      <FacebookSDKContext.Consumer>
        {context => this.props.children(context)}
      </FacebookSDKContext.Consumer>
    );
  }
}

export default FacebookConsumer;
